import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CustomHttpErrorResponse, Error } from '../../../../common/constants/error';
import { NotificationService } from '../../../../common';
import { StatusCodeInitialState, StatusCodeLoad } from './status-code.actions';
import { StatusCodeService } from './status-code.service';
import { FilterPopupChipsModel } from '../models/filter-popup-chips.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface StatusCodeStateModel {
  reasonCode: FilterPopupChipsModel[];
  loaded: boolean;
}

const initialState: StatusCodeStateModel = {
  reasonCode: null,
  loaded: false,
};

@State<StatusCodeStateModel>({
  name: 'statusCode',
  defaults: initialState,
})
@Injectable()
export class StatusCodeState {
  constructor(private reasonCodeService: StatusCodeService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: StatusCodeStateModel): StatusCodeStateModel {
    return state;
  }

  @Selector()
  static getStatusCode(state: StatusCodeStateModel): FilterPopupChipsModel[] {
    return state.reasonCode;
  }

  @Selector()
  static getLoaded(state: StatusCodeStateModel): boolean {
    return state.loaded;
  }

  @Action(StatusCodeLoad)
  getStatusCode(ctx: StateContext<StatusCodeStateModel>): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.reasonCodeService.getStatusCode().pipe(
      map((reasonCode: FilterPopupChipsModel[]) => {
        ctx.patchState({ reasonCode, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(StatusCodeInitialState)
  setInitialState(ctx: StateContext<StatusCodeInitialState>): void {
    ctx.setState(initialState);
  }
}
